<template>
  <div>
    <el-row :gutter="10" v-for="(partner, idx) in partnerList" :key="partner.partner_id">
      <el-col :xs="12" :md="12">
        <std-opt
          v-model="partner.status"
          name="partnerProductStatus"
          :isForm="true"
          :labelText="getNameProductStatus(partner.partner_name)" disabled
          >
        </std-opt>
      </el-col>
      <el-col :xs="12" :md="12">
        <text-field
          v-model="partner.partner_product_id"
          base="product"
          name="partner.id"
          :labelText="getNameProductID(partner.partner_name)"
          :disabled="checkPartnerPidDisabled(partner)"
          @change="onPartnerProductIDChange(partner, $event)"
          >
        </text-field>
      </el-col>
      <el-button
        type="primary"
        @click="setUploadOrUpdate(idx, partner)"
        v-loading="partner.loading"
        >
        {{ $t(changeBtnText(partner)) }}
      </el-button>
    </el-row>
    <el-row v-for="l in limitList" :key="l.key">
      <el-col :span="24">
        <el-alert show-icon :type="l.type" :title="$t(l.key)"></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { fetchList as fetchPartnerList } from '@/api/merchant/partner'
import { uploadPartnerProduct, updateProductStatus, createProductPartner } from '@/api/merchant/product'
import {
  UploadStatus,
  PartnerProductStatus,
  PartnerIDs,
  PartnerType,
  PartnerProductMappingType,
  PartnerStatus
} from '@/enums/partner'
import { usePartnerList } from '@/composables/partner/usePartnerList'

export default {
  name: 'product-partner',
  props: {
    // product id
    dataId: {
      type: String
    },
    value: {
      type: Array,
      default: () => {
        return [
        ]
      }
    },
    limitList: {
      type: Array,
      default: () => {
        return []
      }
    },
    enablePartners: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup () {
    const { filterPartners } = usePartnerList()

    return {
      filterPartners
    }
  },
  data () {
    return {
      uploading: false,
      partners: [],
      partnerData: []
    }
  },
  computed: {
    partnerList () {
      return this.partners.map(partnerConfig => {
        const partnerSetting = this.value.find(v => v.partner_id === partnerConfig.id)
        return {
          ...partnerConfig,
          id: (partnerSetting) ? partnerSetting.id : undefined,
          partner_id: partnerConfig.id,
          partner_name: partnerConfig.name,
          branch_id: (partnerSetting) ? partnerSetting.branch_id : '',
          is_for_delete: (partnerSetting) ? partnerSetting.is_for_delete : true,
          partnerDisabled: partnerConfig.status === PartnerStatus.DISABLE || false,
          partner_product_id: partnerSetting ? partnerSetting.partner_product_id : '',
          status: partnerSetting ? partnerSetting.status : PartnerProductStatus.DISABLE,
          upload_status: partnerSetting ? partnerSetting.upload_status : UploadStatus.WAIT_TO_UPLOAD,
          loading: false
        }
      })
    }
  },
  watch: {
    enablePartners: {
      handler (_enabledPartners) {
        this.partners = this.filterPartners(this.partnerData, _enabledPartners)
      },
      deep: true
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        const query = {filter: `{type: ${PartnerType.Client}}`}
        const res = await fetchPartnerList(query)
        this.partnerData = res.data
        this.partners = this.filterPartners(res.data, this.enablePartners)
      } catch (error) {
        console.log(error)
      }
    },
    setUploadOrUpdate (key, partner = {}) {
      const { id: productPartnerID, partner_id: partnerId, status, upload_status: uploadStatus } = partner
      if (partnerId === PartnerIDs.PChome && uploadStatus === UploadStatus.WAIT_TO_UPLOAD) {
        return this.upload(key, partnerId)
      }
      if (!productPartnerID) {
        return this.createProductPartner(key, partner)
      }
      return this.updateStatus(key, productPartnerID, status)
    },
    upload (partnerIndex, partnerID) {
      this.partnerList[partnerIndex].loading = true
      this.$forceUpdate()
      const data = {
        product_id: parseInt(this.dataId, 0)
      }
      uploadPartnerProduct(partnerID, data).then(res => {
        this.partnerList[partnerIndex].id = res.data.id
        this.partnerList[partnerIndex].partner_product_id = res.data.partner_product_id
        this.partnerList[partnerIndex].status = res.data.status
        this.partnerList[partnerIndex].upload_status = res.data.upload_status
        this.handlePartnerList()
      }).catch(function (err) {
        console.log(err)
      }).finally(() => {
        this.partnerList[partnerIndex].loading = false
        this.$forceUpdate()
      })
    },
    updateStatus (partnerIndex, productPartnerID, status) {
      this.partnerList[partnerIndex].loading = true
      this.$forceUpdate()
      const data = {
        status: status === PartnerProductStatus.DISABLE ? PartnerProductStatus.ENABLE : PartnerProductStatus.DISABLE
      }
      updateProductStatus(productPartnerID, data).then(res => {
        this.partnerList[partnerIndex].status = res.data.status
        this.handlePartnerList()
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.partnerList[partnerIndex].loading = false
        this.$forceUpdate()
      })
    },
    async createProductPartner (partnerIndex, partner = {}) {
      try {
        //  product_id  partner_id  partner_product_id（分銷通路匹配就帶 NA）
        const data = {
          product_id: +this.dataId,
          partner_id: partner.partner_id,
          partner_product_id: partner.product_mapping_type === PartnerProductMappingType.BY_PARTNER ? 'NA' : partner.partner_product_id,
          upload_status: UploadStatus.UPLOADED
        }
        const res = await createProductPartner(data)
        this.partnerList[partnerIndex].id = res.data.id
        this.partnerList[partnerIndex].partner_product_id = res.data.partner_product_id
        this.partnerList[partnerIndex].status = res.data.status
        // upload_status must has been uploaded when create the product partner
        this.partnerList[partnerIndex].upload_status = UploadStatus.UPLOADED

        this.handlePartnerList()
      } catch (error) {
        console.log(error)
      }
    },
    changeBtnText (partner) {
      const { status, upload_status: uploadStatus, partner_id: partnerId } = partner
      if (partnerId === PartnerIDs.PChome && uploadStatus === UploadStatus.WAIT_TO_UPLOAD) {
        return 'api.product.partner.uploadBtn'
      }

      switch (status) {
        case PartnerProductStatus.ENABLE:
          return 'api.product.partner.noSaleBtn'
        case PartnerProductStatus.DISABLE:
          return 'api.product.partner.onSaleBtn'
      }
    },
    getNameProductStatus (partnerName) {
      return partnerName + ' ' + this.$t('api.product.fields.partner.product_status.label')
    },
    getNameProductID (partnerName) {
      return partnerName + ' ' + this.$t('api.product.fields.partner.product_id.label')
    },
    handlePartnerList () {
      // just emit partner setting that had been set
      this.$emit('input', this.partnerList.filter(p => p.id))
    },
    checkPartnerPidDisabled (partner) {
      if (partner.partner_id === PartnerIDs.PChome) {
        return true
      }
      return partner.product_mapping_type !== PartnerProductMappingType.BY_FUNNOW
    },
    onPartnerProductIDChange (_partner, _partnerProductId) {
      // use forceUpdate for list update (deep object change not trigger reactivity)
      this.$forceUpdate()
      this.handlePartnerList()
    }
  }
}
</script>
